export class AxonScriptsService {
  static getPixelCode(id: string) {
    return `
      !function(e, r) {
        var t = ["https://s.axon.ai/pixel.js", "https://res4.applovin.com/p/l/loader.iife.js"];
        if (!e.axon){
          var a = e.axon = function() {
            a.performOperation ? a.performOperation.apply(a, arguments) : a.operationQueue.push(arguments);
          };
          a.operationQueue = [];
          a.ts = Date.now();
          a.eventKey = "${id}";
          for (var n = r.getElementsByTagName("script")[0], o = 0 ; o < t.length; o++) {
            var i = r.createElement("script");
            i.async = !0;
            i.src = t[o];
            n.parentNode.insertBefore(i, n);
          }
        }
      }(window, document);
    `;
  }
}
